import * as Sentry from "@sentry/react";

/**
 * Client-side Sentry, ported from the Next app's instrumentation-client.ts to
 * the React SDK (the Next SDK auto-added browser tracing; here it's explicit).
 *
 * Enabled in production only — like the Plausible script, we don't report from
 * local dev. The DSN is publishable; override with VITE_SENTRY_DSN if needed.
 * Source maps are uploaded at build time by @sentry/vite-plugin (vite.config).
 */
Sentry.init({
  enabled: import.meta.env.PROD,
  environment: import.meta.env.MODE,
  dsn:
    import.meta.env.VITE_SENTRY_DSN ??
    "https://9d091b248a619fa7d6b1856806c5f804@o4505245231415296.ingest.us.sentry.io/4510721055260672",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      maskAllInputs: true,
      blockAllMedia: true,
    }),
    Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
  ],
  tracesSampleRate: 0.2,
  enableLogs: true,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  sendDefaultPii: true,
});
